import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthProvider";

const ProtectedRoute = ({ children }: any) => {
    const { session } = useAuth()

    if (!session) {
        // user is not authenticated
        return <Navigate to="/" />;
    }
    return <>{children}<Outlet/></>
};

export default ProtectedRoute